import React from 'react';
import ReactGA from "react-ga4";

// Initialize GA with  Measurement ID
export const initGA = () => {
    const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

    if (!measurementId) {
        console.log("GA_MEASUREMENT_ID is required but not set.");
        return;
    }
    ReactGA.initialize(measurementId);

};

// Log a page view
export const logGAPageView = (path) => {
    ReactGA.send({ hitType: 'pageview', page: path });
};

// Log an event
export const logGAEvent = (category, action, label) => {
    ReactGA.event({ category, action, label });
};

